import { useState } from "react";
import { toast } from "sonner";
import { RefreshCcw, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { EntityManager } from "@/components/EntityManager";
import { SweepReconciliation } from "@/components/SweepReconciliation";
import { ENTITY_CONFIG } from "@/lib/entities";
import { Button } from "@/components/ui/button";

export default function Sweeps() {
  const [busy, setBusy] = useState(false);
  const [nonce, setNonce] = useState(0);
  const [tab, setTab] = useState("ledger");

  const extractFds = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/sweeps/extract-fds");
      if (data.moved || data.already_tracked) {
        toast.success(
          `Migrated ${data.moved} FDs · ${data.already_tracked} already tracked (${data.scanned} scanned)`
        );
      } else {
        toast.info("No FD-like rows found in Sweeps");
      }
      setNonce((n) => n + 1);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Extract failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <div className="flex gap-1.5">
          {[
            { id: "ledger", label: "Sweep Ledger" },
            { id: "recon", label: "Reconciliation Statement" },
          ].map((t) => (
            <button
              key={t.id}
              onClick={() => setTab(t.id)}
              data-testid={`sweeps-tab-${t.id}`}
              className={`px-3 py-1.5 rounded-md text-xs transition-colors ${
                tab === t.id
                  ? "bg-brand/15 text-foreground border border-brand/30"
                  : "text-muted-foreground border border-white/5 hover:bg-white/[0.04]"
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>
        <Button
          variant="outline"
          size="sm"
          onClick={extractFds}
          disabled={busy}
          data-testid="sweeps-extract-fds-btn"
          className="gap-2"
          title="Move FD-language rows (FD BOOKED / MATURED / REDEEMED) from Sweeps to the Fixed Deposits tab"
        >
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <RefreshCcw className="h-4 w-4" />}
          Extract FDs from Sweeps
        </Button>
      </div>
      {tab === "ledger" ? (
        <EntityManager key={nonce} config={ENTITY_CONFIG.sweeps} />
      ) : (
        <SweepReconciliation nonce={nonce} />
      )}
    </div>
  );
}
